window.Products.Accessory.VeganLeatherCrossbodyPurse = function() {};
window.Products.Accessory.VeganLeatherCrossbodyPurse.inherits(window.Products.Accessory.Accessory);